import type { CompetitorRecord } from "@/lib/compare/types";

const HOME = "https://faceless.video";
const PRICING = "https://faceless.video/pricing";
const TERMS = "https://faceless.video/terms";
const CHECKED = "2026-10-08";

export const FACELESS_VIDEO: CompetitorRecord = {
  slug: "faceless-video",
  name: "Faceless.video",
  aliases: ["faceless.video", "Faceless Video", "Faceless Video AI"],
  url: HOME,
  pricingUrl: PRICING,
  category: "faceless",
  positioning: "AI Agents for Running a Faceless Channel: pick a niche and a Series writes, renders and auto-posts videos on a schedule.",
  plans: [
    {
      name: "Starter",
      monthly: 20,
      metered: "30 credits a month, up to 15 videos",
      includes: [
        "Up to 15 videos a month",
        "30 credits a month",
        "1 social account",
        "Unused credits roll over",
      ],
      sourceUrl: PRICING,
      checkedAt: CHECKED,
      note: "The annual toggle says Save 30% but no annual figure rendered on the page.",
    },
    {
      name: "Daily",
      monthly: 35,
      metered: "60 credits a month, up to 30 videos",
      includes: [
        "Up to 30 videos a month",
        "60 credits a month",
        "Unlimited social accounts",
        "Unused credits roll over",
        "Marked Most popular",
      ],
      sourceUrl: PRICING,
      checkedAt: CHECKED,
      note: "Annual figure not rendered on the page.",
    },
    {
      name: "Double",
      monthly: 59,
      metered: "120 credits a month, up to 60 videos",
      includes: [
        "Up to 60 videos a month",
        "120 credits a month",
        "Unlimited social accounts",
        "Unused credits roll over",
      ],
      sourceUrl: PRICING,
      checkedAt: CHECKED,
      note: "Annual figure not rendered on the page.",
    },
    {
      name: "Studio",
      monthly: 149,
      metered: "350 credits a month, up to 175 videos",
      includes: [
        "Up to 175 videos a month",
        "350 credits a month",
        "Unlimited social accounts",
        "Dedicated support",
        "Unused credits roll over",
      ],
      sourceUrl: PRICING,
      checkedAt: CHECKED,
      note: "Annual figure not rendered on the page.",
    },
  ],
  entryPlanName: "Starter",
  entryPlanIncludes: "30 credits, up to 15 videos a month, 1 connected social account",
  freeTier: "No free plan. A Free Trial button sits in the nav and the terms describe trials that convert to paid, but no trial length or limits are published.",
  trial: "Offered by a nav button and described in the terms, length and limits not published",
  meteringUnit: "Credits; different video types cost different amounts and multi-scene videos charge every scene",
  exportResolution: "Not published. Downloads require opting into email delivery per the FAQ.",
  features: {
    longToShort: { v: "no", note: "No upload-and-clip product" },
    momentRanking: { v: "no" },
    reframing: { v: "no", note: "Generates from scratch" },
    maxSource: { v: "text", note: "No source upload; POV videos run 30 or 65 seconds" },
    layouts: { v: "n/a", note: "Video types instead of layouts" },
    redditStory: { v: "partial", note: "AI Story and POV types, no Reddit import" },
    fakeText: { v: "no", note: "Not on the tools page" },
    aiImages: { v: "yes", note: "One image per scene" },
    voiceover: { v: "yes", note: "Engine and voice count not published" },
    voiceCloning: { v: "n/a", note: "Not on the live site" },
    avatars: { v: "partial", note: "100+ stock presenters, no custom avatars" },
    timelineEditor: { v: "no", note: "Edit script, re-render, swap background" },
    captionStyles: { v: "n/a", note: "Timed captions, styles not enumerated" },
    captionLanguages: { v: "n/a", note: "Not published" },
    bRoll: { v: "n/a", note: "Not on the site" },
    fourK: { v: "n/a", note: "No resolution published" },
    scheduling: { v: "yes", note: "One account per Series, frequency only" },
    analytics: { v: "no" },
    socialTracker: { v: "no" },
    api: { v: "partial", note: "Undocumented publicly, plus an MCP server" },
    webhooks: { v: "n/a", note: "Not on the site" },
    web: { v: "yes" },
    desktop: { v: "no", note: "Not advertised" },
    mobile: { v: "no", note: "Not advertised" },
    teamSeats: { v: "n/a", note: "Dedicated support on Studio, no seats listed" },
    freeTier: { v: "no", note: "Trial button only" },
    trial: { v: "partial", note: "Length and limits not published" },
    metering: { v: "text", note: "Credits per video type and scene" },
    rollover: { v: "yes", note: "Unused credits roll over" },
    refunds: { v: "text", note: "None on monthly; 7 days on annual" },
    cancelInApp: { v: "partial", note: "Stripe portal or Contact form" },
  },
  billingTerms: {
    refunds:
      "Monthly plans: no refunds for partial months. Annual plans: refundable within 7 days of purchase or renewal. Terms sections 8.1 to 8.7.",
    cancel:
      'Cancel through the Stripe customer portal or the Contact form. The terms state that "emails to support don\'t count as a valid cancellation."',
    sourceUrl: TERMS,
    checkedAt: CHECKED,
  },
  quotes: [],
  verification: {
    method: "fetch",
    date: CHECKED,
    note: "Pricing page fetched directly on Oct 8, 2026: Starter $20, Daily $35, Double $59, Studio $149 a month, with the credit and video caps per plan and top-ups of 10 credits for $8, 50 for $35 and 200 for $120. The annual toggle reads Save 30% but no annual figures rendered in the fetch, so annual fields are omitted and need a human browser check. Refund and cancellation terms were read from faceless.video/terms sections 8.1 to 8.7; tools, auto-posting and download facts from faceless.video/tools and the homepage FAQ. The business page's $275 a month figure is not one of the four consumer plans and is not used.",
  },
  seoPattern: "No vs, compare or alternatives pages and no blog; ranks on the exact-match domain for the head term faceless video. No page about Crayo.",
};
